import React from "react";
import { Chip, ChipProps } from "@mui/material";
import { couponCodeDiscountTypesE } from "../../pages/home/components/propertyCard/components/bookingPrice/BookingPrice";
import { useTranslation } from "react-i18next";

const DiscountChip = ({
  couponPercentDiscount,
  couponQuantityDiscount,
  currency,
  sx,
  ...chipProps
}: {
  couponPercentDiscount?: string;
  couponQuantityDiscount?: string;
  currency: string;
} & Partial<ChipProps>) => {
  const { t } = useTranslation();

  const couponCodeDiscountTypes = couponPercentDiscount
    ? couponCodeDiscountTypesE.Percent
    : couponQuantityDiscount
    ? couponCodeDiscountTypesE.Discount
    : undefined;

  const couponCodeDiscountValue =
    couponPercentDiscount || couponQuantityDiscount || undefined;

  return (
    <Chip
      color="success"
      label={`${couponCodeDiscountValue}${
        couponCodeDiscountTypes === couponCodeDiscountTypesE.Discount
          ? currency
          : ""
      } ${t("labels.ofDiscountApplied")}`}
      sx={{
        backgroundColor: "#00C572",
        ...(sx as any),
      }}
      {...chipProps}
    />
  );
};

export default DiscountChip;
